import { extractAmptalkSpeakedAtSeconds } from './amptalk'
import { extractTeamsBeginSeconds } from './teams'
import { extractZoomSpeakedAtSeconds } from './zoom'

/**
 * batch が 90 秒判定に使う発話範囲（最初と最後の発言時刻の差、秒）を書き起こしから求める。
 *
 * batch/src/modules/parseTranscript.ts はファイル全体のどこかが一致した形式を
 * Zoom → Amptalk → Teams の順で採用する（Roleplay 形式は client が受け付けないので省く）。client の形式判定（先頭行で判定）と
 * 採用するパーサがずれることがあるため、判定には表示用の長さではなくこちらを使う。
 * batch がどの形式でも読めない内容は 90 秒判定まで進まないので null を返す
 */
export const calculateBatchSpeechSpanSeconds = (
  content: string,
): number | null => {
  const times = extractSpeakedAtSecondsLikeBatch(content)
  if (times == null) return null
  if (times.length <= 1) return 0

  return times[times.length - 1] - times[0]
}

const extractSpeakedAtSecondsLikeBatch = (content: string): number[] | null => {
  const zoomTimes = extractZoomSpeakedAtSeconds(content)
  if (zoomTimes.length > 0) return zoomTimes

  const amptalkTimes = extractAmptalkSpeakedAtSeconds(content)
  if (amptalkTimes.length > 0) return amptalkTimes

  return extractTeamsBeginSeconds(content)
}
